import { FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';

type FieldPathProps = {
  title: string;
  path: string[] | undefined;
};
const FieldPath: FC<FieldPathProps> = ({ title, path }) => (
  <FlexLayout flexDirection="column" width="full">
    <H4 fontSize="sm" fontWeight="bold" color="secondary">
      {title}
    </H4>
    <H4 color="primaryText" fontSize="md">
      {path?.join('.')}
    </H4>
  </FlexLayout>
);

export default FieldPath;
